
angular.module('app.controllers.meterreading', []).controller('MeterReadingController', ['$rootScope','$scope','$log', '$timeout', '$animate', function ($rootScope, $scope, $log, $timeout, $animate) {

  'use strict';
   angular.module('app', [
    'ui.bootstrap'
    ]);
  $log.debug('MeterReadingController()');

        $scope.subjects = ['Cycle 1', 'Cycle 2', 'Cycle 3', 'Cycle 4', 'Cycle 5', 'Cycle 6', 'Cycle 7', 'Cycle 8', 'Cycle 9', 'Cycle 10', 'Cycle 11', 'Cycle 12', 'Cycle 13', 'Cycle 14', 'Cycle 15', 'Cycle 16', 'Cycle 17', 'Cycle 18', 'Cycle 19', 'Cycle 20', 'Cycle 21','Cycle 22'];
        $scope.selectedItem ="Cycle 1";
        $scope.dropboxitemselected = function (item) {
         
        $scope.selectedItem = item;
        var varSelectedItem = $scope.selectedItem;
        for(var i=1;i<=22;i++)
        { 
          var cycle = "Cycle "+i; 
          if(cycle==$scope.selectedItem){
            document.getElementById(cycle).style.display = 'inline';
          }else{
            document.getElementById(cycle).style.display = 'none';
           }
        }};

}]);

